import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-md bg-red-50 p-4 mt-5"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "ml-3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-sm font-medium text-red-800" }
const _hoisted_6 = { class: "mt-2 text-sm text-red-700" }
const _hoisted_7 = {
  id: "errors",
  class: "card-text"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["innerHTML"]

import {computed } from "vue";
import {ResponseStatus} from "@servicestack/client";


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorSummary',
  props: {
    responseStatus: {},
    title: {}
  },
  setup(__props: any) {

// @ts-ignore
const props = __props;

const computedTitle = computed(() => props.title ?? "Oops. Fix the errors below and try again.");

const hasErrors = computed(() => {
    if(props.responseStatus){
        if(props.responseStatus.errors?.length > 0 
            || props.responseStatus.errorCode?.length > 0
            || props.responseStatus.message?.length > 0)
            return true;
    }
    return false;
});

return (_ctx: any,_cache: any) => {
  return (hasErrors.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "shrink-0" }, [
            _createElementVNode("svg", {
              "aria-hidden": "true",
              class: "h-5 w-5 text-red-400",
              fill: "currentColor",
              viewBox: "0 0 20 20",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "clip-rule": "evenodd",
                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                "fill-rule": "evenodd"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            ((_ctx.responseStatus?.errors?.length ?? 0) > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("h3", _hoisted_5, _toDisplayString(computedTitle.value), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("ul", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responseStatus?.errors, (error) => {
                        return (_openBlock(), _createElementBlock("li", {
                          innerHTML: error.message
                        }, null, 8, _hoisted_8))
                      }), 256))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("h3", {
                    class: "text-sm font-medium text-red-800",
                    innerHTML: _ctx.responseStatus?.message
                  }, null, 8, _hoisted_10)
                ]))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})